const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全私密观看',
    desc: '黑料在线无需注册登录，无需提供任何个人信息，保护您的隐私安全。所有黑料视频均可匿名在线观看，不留浏览痕迹。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载播放',
    desc: '黑料在线播放采用先进的视频加速技术，支持高清流畅播放。无论您使用电脑还是手机，都能享受黑料在线免费观看的极速体验。',
    color: 'accent',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日新鲜更新',
    desc: '黑料在线保持每日内容更新，全天候追踪娱乐圈、网红圈最新爆料。最新黑料大瓜第一时间上线，满足您在线观看黑料的需求。',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝适配',
    desc: '黑料在线视频完美适配电脑、平板和手机端。移动端同样支持高清黑料在线播放，随时随地轻松吃瓜，不受设备限制。',
    color: 'primary',
  },
];

const colorStyles: Record<string, { bg: string; iconBg: string; text: string }> = {
  primary: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-accent-100', text: 'text-accent-600' },
  secondary: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-secondary-100', text: 'text-secondary-600' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
            <i className="ri-star-smile-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">为什么选择黑料在线 · 四大核心优势</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feat) => {
            const cs = colorStyles[feat.color];
            return (
              <div key={feat.title} className={`p-5 rounded-lg border ${cs.bg} hover:border-background-300 transition-colors`}>
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${cs.iconBg} mb-4`}>
                  <i className={`${feat.icon} ${cs.text} text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}